import React, { useLayoutEffect, useRef } from "react";
import { SegmentedOption } from "@axum/ax-design";
import { SCROLL_TRACK, ScrollHint, ScrollMoreButtons, useSyncedScroll } from "../../Common/ScrollHint";
import { SectionTabs } from "./styles";

interface Props {
  options: SegmentedOption<string>[];
  value: string;
  onChange: (value: string) => void;
}

const PEEK = 56;

export default (props: Props) => {
  const host = useRef<HTMLDivElement>(null);
  const hint = useSyncedScroll(host);

  useLayoutEffect(() => {
    const el = host.current && host.current.querySelector<HTMLElement>(`.${SCROLL_TRACK}`);
    const active = el && el.querySelector<HTMLElement>(".ax-segmented-btn.is-active");
    if (!el || !active) return;
    const left = active.offsetLeft - PEEK;
    const right = active.offsetLeft + active.offsetWidth + PEEK - el.clientWidth;
    if (el.scrollLeft > left) el.scrollTo({ left, behavior: "smooth" });
    else if (el.scrollLeft < right) el.scrollTo({ left: right, behavior: "smooth" });
  }, [props.value]);

  return (
    <ScrollHint ref={host} className={hint.className}>
      <SectionTabs className={SCROLL_TRACK} aria-label="Sección" options={props.options} value={props.value} onChange={props.onChange} />
      <ScrollMoreButtons hint={hint} previous="Ver pestañas anteriores" next="Ver más pestañas" />
    </ScrollHint>
  );
};
